/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AccessRequestStatus {
    Processing = 'Processing',
    Granted = 'Granted',
    Denied = 'Denied'
}


export function instanceOfAccessRequestStatus(value: any): boolean {
    for (const key in AccessRequestStatus) {
        if (Object.prototype.hasOwnProperty.call(AccessRequestStatus, key)) {
            if (AccessRequestStatus[key as keyof typeof AccessRequestStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccessRequestStatusFromJSON(json: any): AccessRequestStatus {
    return AccessRequestStatusFromJSONTyped(json, false);
}

export function AccessRequestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestStatus {
    return json as AccessRequestStatus;
}

export function AccessRequestStatusToJSON(value?: AccessRequestStatus | null): any {
    return value as any;
}

export function AccessRequestStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AccessRequestStatus {
    return value as AccessRequestStatus;
}

